module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/line-icon-d70e8bc911dcf08d18df91733959f3cb.svg&quot;;"